import 'prop-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

/*
 *
 * Constants: `@dbh/get-html-privacy-sensitive-attributes`.
 *
 */// When we want `hotjar` to show sensitive privacy fields without asterisks (i.e credit card number)
// in the dashboard, we have to print `data-hj-suppress=true`. Otherwise we have to print
// `data-hj-whitelist=true`, to be sure that `hotjar` does not choose by itself to obfuscate the
// field with asterisks in the dashboard. These props are exclusive and can only be passed as
// `true`, `false` has no effect.
// The same for `Microsoft Clarity`.
// @see {@link https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api#html-apis}
// @see {@link https://help.hotjar.com/hc/en-us/articles/115012439167-How-to-Suppress-Text-Images-and-User-Input-from-Collected-Data}
// @see {@link https://help.hotjar.com/hc/en-us/articles/115015563287-How-to-Show-Elements-and-Keystrokes-in-Data-Collection}
const RECORDING_HTML_MASK_ATTRIBUTES={"data-hj-suppress":!0,"data-clarity-mask":!0};const RECORDING_HTML_UN_MASK_ATTRIBUTES={"data-hj-allow":!0,"data-clarity-unmask":!0};

/**
 * Returns the `HTML` attributes for privacy-sensitive elements.
 * When we want `hotjar` or `Microsoft Clarity` to show sensitive privacy fields
 * without asterisks (i.e credit card number) in the dashboard, we have to print
 * `data-hj-suppress=true`, `data-clarity-mask=true`. Otherwise we have to print
 * `data-hj-whitelist=true`, `data-clarity-mask=true`, to be sure that `hotjar`
 * and `Microsoft Clarity` does not choose by itself to obfuscate the field with
 * asterisks in the dashboard. These props are exclusive and can only be passed
 * as `true`, `false` has no effect.
 * @see {@link https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api#html-apis}
 * @see {@link https://help.hotjar.com/hc/en-us/articles/115012439167-How-to-Suppress-Text-Images-and-User-Input-from-Collected-Data}
 * @see {@link https://help.hotjar.com/hc/en-us/articles/115015563287-How-to-Show-Elements-and-Keystrokes-in-Data-Collection}
 * @param {boolean} privacySensitive .
 * @return {Object?} .
 */const getHtmlPrivacySensitiveAttributes=withConformsTo("getHtmlPrivacySensitiveAttributes",[],a=>"boolean"==typeof a?a?RECORDING_HTML_MASK_ATTRIBUTES:RECORDING_HTML_UN_MASK_ATTRIBUTES:void 0);

export { getHtmlPrivacySensitiveAttributes as default };
